// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"de514c11","236":"e0ec3309","703":"a43af0c3","787":"42fc690c"}[chunkId] + ".chunk.js";
};